var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('H1',[_vm._v("Sandbox")]),_c('map2d',{staticClass:"mapBlock",attrs:{"trackPath":_vm.trackPath,"segments":_vm.segmPath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }